import { Tooltip, Typography } from "@material-ui/core";
import { Box, Grid } from "@mui/material";
import { format } from "date-fns";
import jwt_decode from "jwt-decode";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Document, Page, pdfjs } from "react-pdf";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { REACT_NDA_EDIT } from "../../actions/EndPoints";
import { ThemeContext } from "../../theme/ThemeContext";
import GlobalDataContext from "../GlobalDataContext";
import EditIcon from "../Person/EditIcon";
import { getNDADocuments } from "./NDASlice";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

function NDA() {
  var decoded_jwtToken = jwt_decode(
    localStorage.getItem(process.env.REACT_APP_ACCESS_TOKEN)
  );
  const history = useHistory();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { darkMode } = useContext(ThemeContext);
  const { setCompanySettings } = useContext(GlobalDataContext);
  const companySettings = JSON.parse(localStorage.getItem("companySettings"));

  const [pdfUrl1, setPdfUrl1] = useState("");
  const [fileName1, setFileName1] = useState("");
  const [date1, setDate1] = useState("");
  const [pdfUrl2, setPdfUrl2] = useState("");
  const [fileName2, setFileName2] = useState("");
  const [date2, setDate2] = useState("");
  const [data, setData] = useState([]);
  const [ndaDocuments, setNdaDocuments] = useState([]);

  const formatDate = (dateFormat) => {
    switch (dateFormat) {
      case "dd-MM-yyyy":
        return "dd-MM-yyyy";
      case "MM-dd-yyyy":
        return "MM-dd-yyyy";
      case "yyyy-MM-dd":
        return "yyyy-MM-dd";
      default:
        return "yyyy-MM-dd";
    }
  };

  const handleNDAUpload = (data) => {
    history.push({
      pathname: REACT_NDA_EDIT,
      state: { data: data },
    });
  };

  useEffect(() => {
    dispatch(getNDADocuments())
      .unwrap()
      .then((data) => {
        if (data.code === "MSGS4000" && Array.isArray(data.data)) {
          const docs = data.data;
          setNdaDocuments(docs);
          setData(docs);

          if (docs[0]) {
            setFileName1(docs[0].fileName?.replace(/\.[^/.]+$/, "") || "");
            setDate1(
              format(
                new Date(docs[0].createdAt),
                formatDate(companySettings.dateFormat)
              )
            );
          }

          if (docs[1]) {
            setFileName2(docs[1].fileName?.replace(/\.[^/.]+$/, "") || "");
            setDate2(
              format(
                new Date(docs[1].createdAt),
                formatDate(companySettings.dateFormat)
              )
            );
          }
        } else {
          setPdfUrl1("");
          setPdfUrl2("");
          setFileName1("");
          setFileName2("");
          setDate1("");
          setDate2("");
          setNdaDocuments([]);
        }
      })
      .catch((err) => {
        console.error("Failed to fetch NDA documents", err);
        setPdfUrl1("");
        setPdfUrl2("");
        setFileName1("");
        setFileName2("");
        setDate1("");
        setDate2("");
      });
  }, []);

  useEffect(() => {
    if (darkMode) {
      document.body.classList.add("darkMode");
    } else {
      document.body.classList.remove("darkMode");
    }
    return () => {
      document.body.classList.remove("darkMode");
    };
  }, [darkMode]);

  const [numPages1, setNumPages1] = useState(null);
  const [numPages2, setNumPages2] = useState(null);

  const onDocumentLoadSuccess1 = ({ numPages }) => {
    setNumPages1(numPages);
  };

  const onDocumentLoadSuccess2 = ({ numPages }) => {
    setNumPages2(numPages);
  };

  const isPdf = (url) => {
    return url?.toLowerCase().endsWith(".pdf");
  };

  return (
    <>
      <Grid
        container
        alignItems="center"
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          padding: "16px",
        }}
      >
        <Box sx={{ flexGrow: 1 }}>
          <Typography
            variant="h3"
            style={{
              color: darkMode ? "#fff" : "#3D4977",
              marginLeft: "-15px",
            }}
          >
            {t("NDA_HEADER")}
          </Typography>
        </Box>
        <Box
          sx={{ marginRight: "-20px" }}
          onClick={() => handleNDAUpload(data)}
        >
          <EditIcon />
        </Box>
      </Grid>
      <Box
        sx={{
          width: "100%",
          height: "calc(100vh - 160px)",
          backgroundColor: darkMode ? "#0E2A41" : "white",
          paddingTop: "0px",
          paddingBottom: "8px",
          borderRadius: "8px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          position: "relative",
        }}
      >
        <Box
          style={{
            height: "100%",
            display: "flex",
            padding: "40px 50px 30px 50px",
            gap: "10px",
          }}
        >
          <Grid
            item
            sm={6}
            xs={12}
            style={{
              height: "100%",
              width: "100%",
              minWidth: "455px",
              display: "flex",
              flexDirection: "column",
              backgroundColor: darkMode ? "#1b3245" : "#f5f5f5e6",
              position: "relative",
              padding: "1px  25px 30px 25px",
              borderRadius: "9px",
              opacity: 1,
            }}
          >
            <Box
              style={{
                display: "flex",
                justifyContent: "space-between",
                padding: "10px 1px 10px 1px",
                alignItems: "center",
              }}
            >
              <Tooltip title={fileName1}>
                <Typography
                  style={{
                    color: darkMode ? "#fff" : "#000000",
                    opacity: "0.8",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    maxWidth: "290px",
                    fontSize: "18px",
                    fontWeight: "bold",
                    fontFamily: "normal normal bold 24px/29px Roboto",
                  }}
                >
                  {fileName1}
                </Typography>
              </Tooltip>
              <Typography
                style={{
                  color: darkMode ? "#fff" : "black",
                  opacity: "0.6",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  maxWidth: "150px",
                  fontFamily: "normal normal normal 20px/24px Roboto",
                }}
              >
                {date1}
              </Typography>
            </Box>
            <Box
              sx={{
                overflowY: "auto",
                overflowX: "hidden",
                borderRadius: "3px",
              }}
            >
              {ndaDocuments[0]?.documentURL && (
                <Document
                  file={ndaDocuments[0].documentURL}
                  onLoadSuccess={onDocumentLoadSuccess1}
                >
                  {[...Array(numPages1)].map((_, index) => (
                    <Page
                      key={`page2_${index + 1}`}
                      pageNumber={index + 1}
                      scale={1.5}
                      renderAnnotationLayer={false}
                      renderTextLayer={false}
                      className="pdf-page"
                    />
                  ))}
                </Document>
              )}
            </Box>
          </Grid>

          {ndaDocuments[1]?.documentURL && (
            <Grid
              item
              sm={6}
              xs={12}
              style={{
                height: "100%",
                width: "100%",
                minWidth: "455px",
                display: "flex",
                flexDirection: "column",
                backgroundColor: darkMode ? "#1b3245" : "#f5f5f5e6",
                padding: "1px  25px 30px 25px",
                borderRadius: "9px",
                opacity: 1,
              }}
            >
              <Box
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "10px 1px 10px 1px",
                  alignItems: "center",
                }}
              >
                <Tooltip title={fileName2}>
                  <Typography
                    style={{
                      color: darkMode ? "#fff" : "black",
                      opacity: "0.8",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      maxWidth: "290px",
                      fontSize: "18px",
                      fontWeight: "bold",
                      fontFamily: "normal normal bold 24px/29px Roboto",
                    }}
                  >
                    {fileName2}
                  </Typography>
                </Tooltip>
                <Typography
                  style={{
                    color: darkMode ? "#fff" : "black",
                    opacity: "0.6",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    maxWidth: "150px",
                    fontFamily: "normal normal normal 20px/24px Roboto",
                  }}
                >
                  {date2}
                </Typography>
              </Box>
              <Box
                sx={{
                  overflowY: "auto",
                  overflowX: "hidden",
                  borderRadius: "3px",
                }}
              >
                <Document
                  file={ndaDocuments[1].documentURL}
                  onLoadSuccess={onDocumentLoadSuccess2}
                >
                  {[...Array(numPages2)].map((_, index) => (
                    <Page
                      key={`page2_${index + 1}`}
                      pageNumber={index + 1}
                      scale={1.5}
                      renderAnnotationLayer={false}
                      renderTextLayer={false}
                      className="pdf-page"
                    />
                  ))}
                </Document>
              </Box>
            </Grid>
          )}
        </Box>
      </Box>
    </>
  );
}

export default NDA;
